const React = require('react');
const {getRFC3339} = require('mn-utils/formatTime');

const formatCCSymbol = require('../../../../../../utils/formatCCSymbol');

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
  DisplayDateTimeAdmin
} = require("../../../../../dumb/DisplayData");

const RowA = require('../../../../../dumb/Row/A');
const ColA = require('../../../../../dumb/Col/A');

module.exports = ({data}) => {
  const time = data.created_at || '';
  const fiatAmount = data.fiat_value || 0;
  const fiatCode = data.fiat_code || '';

  return (
    <RowA>
      <ColA className="wmin155 fx1">
        <DisplayIdAdmin>{data.id}</DisplayIdAdmin>
      </ColA>
      <ColA className="wmin120">
        <DisplayDateTimeAdmin date={time} />
      </ColA>
      <ColA className="wmin200 fx1">
        <DisplayDataAdmin>{data.username}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin100 fx1">
        <DisplayDataAdmin>{formatCCSymbol(data.cc_code)}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin150 fx1">
        <DisplayAmountAdmin
          amount={fiatAmount}
          symbol={fiatCode}
          type="fiat"
        />
      </ColA>
    </RowA>
  );
};
